import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
const dealers = [{
  name: 'Mercedes-Benz Haxaco Hà Nội',
  address: '46 Láng Hạ, Đống Đa, Hà Nội',
  phone: '(024) 3514 8888',
  hours: 'Thứ 2 - CN: 8:00 - 19:00'
}, {
  name: 'Mercedes-Benz Vietnam Star TP.HCM',
  address: '2 Trường Chinh, Tân Phú, TP.HCM',
  phone: '(028) 3997 7777',
  hours: 'Thứ 2 - Thứ 7: 8:00 - 18:00'
}, {
  name: 'Mercedes-Benz An Du Hà Nội',
  address: '11 Phạm Hùng, Mỹ Đình, Hà Nội',
  phone: '(024) 3768 9999',
  hours: 'Thứ 2 - CN: 8:30 - 19:30'
}];
export function Dealerships() {
  return <section className="py-24 bg-gray-900 text-white" data-id="element-65">
      <div className="max-w-7xl mx-auto px-6" data-id="element-66">
        <div className="text-center mb-16" data-id="element-67">
          <h2 className="text-3xl md:text-4xl font-light mb-4" data-id="element-68">TÌM ĐẠI LÝ</h2>
          <p className="text-gray-400 font-light" data-id="element-69">
            Ghé thăm các đại lý chính hãng trên toàn quốc
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-70">
          {dealers.map((dealer, index) => <div key={index} className="bg-white/5 border border-white/10 p-8 rounded-2xl hover:bg-white/10 transition-colors duration-300" data-id="element-71">
              <h3 className="text-xl font-medium text-[#D4AF37] mb-6" data-id="element-72">
                {dealer.name}
              </h3>
              <div className="space-y-4 text-gray-300 font-light text-sm" data-id="element-73">
                <div className="flex items-start gap-3" data-id="element-74">
                  <MapPin className="w-5 h-5 text-gray-500 shrink-0" data-id="element-75" />
                  <span data-id="element-76">{dealer.address}</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-77">
                  <Phone className="w-5 h-5 text-gray-500 shrink-0" data-id="element-78" />
                  <span data-id="element-79">{dealer.phone}</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-80">
                  <Clock className="w-5 h-5 text-gray-500 shrink-0" data-id="element-81" />
                  <span data-id="element-82">{dealer.hours}</span>
                </div>
              </div>
              <button className="mt-8 w-full py-3 border border-white/20 rounded-full hover:bg-white hover:text-black transition-all text-xs uppercase tracking-widest" data-id="element-83">
                Chỉ Đường
              </button>
            </div>)}
        </div>
      </div>
    </section>;
}